module.exports = __webpack_public_path__ + "static/media/team.6357062c.svg";